import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import getLowestEndpointPrice from '../../../utilities/get-lowest-endpoint-price';
import {format} from 'date-fns';
import {graphql, useLazyLoadQuery} from 'react-relay/hooks';
import useQuery from '../../../useQuery';
import i18n from '../../../i18n';
import {FormattedMessage} from 'react-intl';
import getServiceUrl from '../../../utilities/get-service-url';
import {ErrorBoundary} from 'react-error-boundary';
import ErrorFallback from '../../../components/ErrorFallback';
import Skeleton from '../../../components/Skeleton';

const EventCard = React.memo(({serviceId}) => {
    const {serviceById} = useLazyLoadQuery(
        graphql`
            query upcomingEventsBasicWarpPagesServiceByIdQuery($id: String) {
                serviceById(id: $id) {
                    id
                    name
                    target
                    slug
                    description
                    warp
                    tags
                    endpoints {
                        id
                        price
                        labels
                    }
                }
            }
        `,
        {id: serviceId}
    );
    const location = useLocation();
    const {description, slug, warp, tags, id} = serviceById;
    const {locale = 'uk'} = useQuery();
    const target = serviceById.target ? format(new Date(serviceById.target), 'dd-MM-yyyy') : null;
    const lowestTicketPrice = React.useMemo(() => {
        return getLowestEndpointPrice(serviceById.endpoints);
    }, [serviceById]);
    const serviceUrl = getServiceUrl({id, description, slug, warp, tags, location});
    return (
        <div className='upcoming-events__event basic-endpoint border-radius-0dot75rem border-1px-solid padding-1dot25rem mw768-padding-2rem'>
            <div className='display-flex flex-direction-column-row'>
                <div className=' mw768-flex-1 mw768-margin-right-1rem'>
                    <div className='basic-endpoint__title text-lg medium mw768-text-xl'>
                        {i18n(serviceById, 'name', locale)}
                    </div>
                    {!!target && 
                        <div className='basic-endpoint__date text-sm mw768-text-md padding-top-0dot5rem'>{target}</div>
                    }
                </div>
                <div className='display-flex mw768-flex-1 justify-content-space-between align-items-center mw768-align-self-center mw768-justify-content-flex-end padding-top-1rem mw768-padding-top-0'>
                    <p className='basic-endpoint__price mw768-margin-right-2dot5rem'><FormattedMessage defaultMessage='from'/> {lowestTicketPrice} UAH</p>
                    <div className='width-7rem min-height-2dot625rem'>
                        <Link to={serviceUrl} className='basic-endpoint__btn border-1px-solid padding-0dot5rem border-radius-0dot5rem text-md medium display-flex position-relative justify-content-center shadow-xs basic-endpoint__btn--empty cursor-pointer width-100percent buy-btn-animation--backwards'>
                            <span className='add-to-cart--visible'><FormattedMessage defaultMessage='To event'/></span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
});

const UpcomingEvents = ({serviceList}) => {
    
    return (
        <ErrorBoundary {...{FallbackComponent: ErrorFallback}}>
            <div className='upcoming-events display-flex flex-direction-column row-gap-1dot5rem'>
                <p className='basic__text display-xs semibold'><FormattedMessage defaultMessage='Other events by merchant'/></p>
                <React.Suspense fallback={<Skeleton/>}>
                    {serviceList.map(service =>
                        <EventCard key={service.id} {...{serviceId: service.id}}/>
                    )}
                </React.Suspense>
            </div>
        </ErrorBoundary>
    )
};

export default React.memo(UpcomingEvents)